import React from "react";
import { useSelector } from "react-redux";

const AppHomeMobileButton = ({ className = "container d-block d-lg-none", style }) => {
  const { currentCustomer } = useSelector((state) => state.store);

  const openAppHome = () => {
    const appHome = window["APP_HOME"];

    if (!appHome) {
      return;
    }

    const targetUrl = appHome.startsWith?.("http")
      ? appHome
      : `${window.location.protocol}//${window.location.host}${appHome}`;

    window.open(targetUrl, "_blank");
  };

  return (
    <div className={className} style={style}>
      <button
        type="button"
        className="gc-btn btn-fill-primary w-100"
        onClick={openAppHome}
      >
        {currentCustomer?.apps_config?.systemName || "Gobierno Electrónico"}
      </button>
    </div>
  );
};

export default AppHomeMobileButton;